import React, { useState } from "react";
import "../../styles/components/WebsitesShowcase-2.css";

import arrowCircle from "../../img/hero/arrow-circle-4.png";

import website1 from "../../img/websites/website-1.webp";
import website2 from "../../img/websites/website-2.webp";
import website3 from "../../img/websites/website-3.webp";
import website4 from "../../img/websites/website-4.webp";

const websites = [
    {
        title: "DSTLRY",
        description:
            "eCommerce and digital marketplace for a premium comic book publisher with a creator-owned model, featuring top names like Scott Snyder and James Tynion IV. We built the storefront supporting physical and digital comic sales, pre-orders, and a digital resale marketplace.",
        image: website1,
        url: "https://dstlry.co/",
        stat: "+42%",
        statLabel: "Conversion Growth",
        tech: ["Figma", "C++", "Java", "Figma"],
        launch: "3 Weeks",
        launchLabel: "To launch",
    },
    {
        title: "SkinHelper",
        description:
            "Ukrainian cosmetics eCommerce platform with AI-powered skin analysis, personalized product recommendations, and online cosmetologist consultations. We built the full store combining professional skincare retail with an intelligent product matching system.",
        image: website2,
        url: "https://www.skinhelper.store/",
        stat: "+42%",
        statLabel: "Conversion Growth",
        tech: ["React", "Node.js", "Figma"],
        launch: "3 Weeks",
        launchLabel: "To launch",
    },
    {
        title: "Hulken",
        description:
            "Online store for the original foldable rolling tote bag — 1M+ units sold worldwide, featured in CNN, Forbes, and Good Morning America. We developed the Shopify-based storefront with product customization, bundle builder, and localized shopping experience.",
        image: website3,
        url: "https://hulken.com/",
        stat: "+42%",
        statLabel: "Conversion Growthy",
        tech: ["React", "Python", "AI", "Figma"],
        launch: "3 Weeks",
        launchLabel: "To launch",
    },
    {
        title: "Khaite",
        description:
            "eCommerce platform for a New York-based luxury womenswear brand with $100M+ in revenue, worn by Katie Holmes and Rihanna. We built the online store powering their direct-to-consumer sales across clothing, leather goods, and accessories.",
        image: website4,
        url: "https://khaite.com/",
        stat: "+42%",
        statLabel: "Conversion Growth",
        tech: ["React", "Firebase", "Figma"],
        launch: "3 Weeks",
        launchLabel: "To launch",
    },
];

export default function WebsitesShowcase() {
    const [active, setActive] = useState(0);
    const [isChanging, setIsChanging] = useState(false);

    const current = websites[active];

    const switchTo = (index) => {
        if (index === active) return;

        setIsChanging(false);
        setActive(index);

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setIsChanging(true);
            });
        });
    };

    const goPrev = () => {
        switchTo(active === 0 ? websites.length - 1 : active - 1);
    };

    const goNext = () => {
        switchTo(active === websites.length - 1 ? 0 : active + 1);
    };

    return (
        <section className="ws ws-anim">
            <h2 className="ws__title ws-anim__title">Websites</h2>

            <div className={`ws__card ws-anim__card ${isChanging ? "ws-switch__card" : ""}`}>
                <img
                    className="ws__image"
                    src={current.image}
                    alt=""
                />

                <div
                    className="ws__content ws-anim__content"
                    onAnimationEnd={() => setIsChanging(false)}
                >
                    <h3 className="ws__card-title">{current.title}</h3>
                    <p className="ws__description">{current.description}</p>
                </div>

                <a
                    href={current.url}
                    target="_blank"
                    rel="noreferrer"
                    className="ws__button"
                >
                    <span>Visit website</span>
                    <img src={arrowCircle} alt="" />
                </a>

                {/* <div
                    className="ws__glass-row ws-anim__glass"
                >
                    <div className="ws__glass">
                        <div className="ws__glass-number">{current.stat}</div>
                        <div className="ws__glass-label">{current.statLabel}</div>
                    </div>

                    <div className="ws__glass ws__glass--wide">
                        <div className="ws__glass-number">Built with</div>
                        <div className="ws__tech">{current.tech.join(" • ")}</div>
                    </div>

                    <div className="ws__glass ws__glass--small">
                        <div className="ws__glass-number">{current.launch}</div>
                        <div className="ws__glass-label">{current.launchLabel}</div>
                    </div>
                </div> */}
            </div>

            <div className="ws__controls ws-anim__controls">
                <button
                    className="ws__arrow ws__arrow--left"
                    type="button"
                    onClick={goPrev}
                />

                <div className="ws__dots">
                    {websites.map((_, index) => (
                        <button
                            key={index}
                            type="button"
                            className={active === index ? "ws__dot ws__dot--active" : "ws__dot"}
                            onClick={() => switchTo(index)}
                        />
                    ))}
                </div>

                <button
                    className="ws__arrow ws__arrow--right"
                    type="button"
                    onClick={goNext}
                />
            </div>
        </section>
    );
}
